import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import "twin.macro"
import Navbar from "../components/Navbar"
import HeroSection from "../components/Section/HeroSection"
import ServiceSection from "../components/Section/ServiceSection"
import DesignSample from "../components/Section/DesignSample"
import CountSection from "../components/Section/CountSection"
import CompaniesSection from "../components/Section/CompaniesSection"
import Stories from "../components/Section/Stories"
import EmailSection from "../components/Section/EmailSection"
import LastSection from "../components/Section/LastSection"

const BlogIndex: React.FC = () => {
  return (
    <Layout>
      <Seo title="Home" />
      <Navbar />
      <HeroSection />
      <ServiceSection />
      <DesignSample />
      {/*<CountSection />*/}
      <CompaniesSection />
      <Stories />
      <EmailSection />
      <LastSection />
    </Layout>
  )
}

export default BlogIndex
